import { Moon, Sun, Monitor } from 'lucide-react';
import { useTheme } from './ThemeProvider';

interface ThemeToggleProps {
  showLabel?: boolean;
  variant?: 'icon' | 'dropdown';
  className?: string;
}

export function ThemeToggle({ showLabel = false, variant = 'icon', className = '' }: ThemeToggleProps) {
  const { theme, setTheme, resolvedTheme } = useTheme();

  if (variant === 'dropdown') {
    return (
      <div className={`relative group ${className}`}>
        <button
          className="flex items-center gap-2 p-2 rounded-md hover:bg-sidebar-accent transition-colors text-sidebar-foreground"
          aria-label="Alternar tema"
        >
          {resolvedTheme === 'dark' ? (
            <Moon className="w-5 h-5" />
          ) : (
            <Sun className="w-5 h-5" />
          )}
          {showLabel && <span className="text-sm">Tema</span>}
        </button>
        
        <div className="absolute right-0 mt-2 w-36 py-1 bg-card border border-border rounded-md shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all z-50">
          <button
            onClick={() => setTheme('light')}
            className={`w-full flex items-center gap-2 px-3 py-2 text-sm hover:bg-accent/10 transition-colors ${
              theme === 'light' ? 'text-accent' : 'text-foreground'
            }`}
          >
            <Sun className="w-4 h-4" />
            Claro
          </button>
          <button
            onClick={() => setTheme('dark')}
            className={`w-full flex items-center gap-2 px-3 py-2 text-sm hover:bg-accent/10 transition-colors ${
              theme === 'dark' ? 'text-accent' : 'text-foreground'
            }`}
          >
            <Moon className="w-4 h-4" />
            Escuro
          </button>
          <button
            onClick={() => setTheme('system')}
            className={`w-full flex items-center gap-2 px-3 py-2 text-sm hover:bg-accent/10 transition-colors ${
              theme === 'system' ? 'text-accent' : 'text-foreground'
            }`}
          >
            <Monitor className="w-4 h-4" />
            Sistema
          </button>
        </div>
      </div>
    );
  }

  // Variant: icon (toggle simples)
  const toggleTheme = () => {
    setTheme(resolvedTheme === 'dark' ? 'light' : 'dark');
  };

  return (
    <button
      onClick={toggleTheme}
      className={`p-2 rounded-md hover:bg-sidebar-accent transition-colors text-sidebar-foreground ${className}`}
      aria-label={resolvedTheme === 'dark' ? 'Ativar modo claro' : 'Ativar modo escuro'}
    >
      {resolvedTheme === 'dark' ? (
        <Sun className="w-5 h-5" />
      ) : (
        <Moon className="w-5 h-5" />
      )}
    </button>
  );
}
